import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import Navigation from "./navigation/navigation";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "./theme/theme.css";

// Warm Residential design tokens fed into Ant Design.
const antTheme = {
  token: {
    colorPrimary: "#2f5d4f",
    colorInfo: "#2f5d4f",
    colorSuccess: "#3e7a66",
    colorWarning: "#c89a3c",
    colorError: "#c2603d",
    colorText: "#2a2622",
    colorTextSecondary: "#6b6258",
    colorBgContainer: "#fffdf8",
    colorBgLayout: "#f6f1e7",
    colorBorder: "#e3daca",
    colorBorderSecondary: "#ece3d3",
    fontFamily: "'Hanken Grotesk', -apple-system, 'Segoe UI', sans-serif",
    borderRadius: 12,
    controlHeight: 40,
  },
  components: {
    Menu: {
      darkItemBg: "transparent",
      darkSubMenuItemBg: "transparent",
      darkItemColor: "rgba(246, 241, 231, 0.78)",
      darkItemHoverBg: "rgba(246, 241, 231, 0.08)",
      darkItemHoverColor: "#ffffff",
      darkItemSelectedBg: "rgba(194, 96, 61, 0.22)",
      darkItemSelectedColor: "#ffffff",
    },
    Button: { fontWeight: 600, primaryShadow: "none" },
    Table: { headerBg: "#efe7d7", headerColor: "#6b6258", borderColor: "#e3daca" },
  },
};

function App() {
  return (
    <ConfigProvider theme={antTheme}>
      <Router>
        <>
          <Navigation />
          <ToastContainer />
        </>
      </Router>
    </ConfigProvider>
  );
}

export default App;
